export function checkSponsoredWidgetValidity(widget) {
    if (widget.startDateTime && isNaN(Date.parse(widget.startDateTime))) {
        return '`startDateTime` is invalid';
    }
    if (widget.endDateTime && isNaN(Date.parse(widget.endDateTime))) {
        return '`endDateTime` is invalid';
    }
    return null;
}
